import { Provider } from '@angular/core';
import { UnleashClient } from 'unleash-proxy-client';
import { FeatureFlagLocalStorageProvider } from '../services/feature-flags-utils';

export interface UnleashClientConfig {
  url: string;
  clientKey: string;
  appName: string;
  refreshInterval: number;
}

export function provideUnleashClient(config: UnleashClientConfig): Provider {
  return {
    provide: UnleashClient,
    useFactory: (storageProvider: FeatureFlagLocalStorageProvider) =>
      new UnleashClient({
        url: config.url,
        clientKey: config.clientKey,
        appName: config.appName,
        refreshInterval: config.refreshInterval,
        storageProvider: storageProvider,
        // Usage metrics POST hits a CORS gap in the shared Unleash Edge gateway (AI-572) —
        // we don't consume this data, so disable it rather than wait on that infra fix.
        disableMetrics: true,
      }),
    deps: [FeatureFlagLocalStorageProvider],
  };
}
